'use client';

import { type Image } from '@metmuseum/types';
import MinimalHeader from 'components/headers/minimal-header';
import HeroBanner from 'components/hero-banner';
import { type ILink } from 'helpers/helpers';

/* Ideally the banner will take 1x1 image and a 3x1 */
/* Some older pages don't have  a 3x1 so the 16x9 is used as a fallback */
const PageHeader = ({
	availableLanguages = [],
	children,
	credit,
	description,
	displayLanguageFilter = false,
	hideBottomBorder = false,
	landscapeImage,
	languageDescriptions = [],
	links,
	squareImage,
	title,
	wideLandscapeImage,
}: PageHeaderProps) => {
	return (
		<div>
			{(wideLandscapeImage || squareImage || landscapeImage) && (
				<HeroBanner
					credit={credit}
					squareImage={squareImage}
					wideLandscapeImage={wideLandscapeImage || landscapeImage}
				/>
			)}
			<MinimalHeader
				heading={title}
				description={description}
				links={links}
				displayLanguageFilter={displayLanguageFilter}
				availableLanguages={availableLanguages}
				languageDescriptions={languageDescriptions}
				hideBottomBorder={hideBottomBorder}
			>
				{children}
			</MinimalHeader>
		</div>
	);
};

export interface PageHeaderProps {
	children?: any;
	credit?: string;
	description?: string;
	landscapeImage?: Image;
	squareImage?: Image;
	title?: string;
	links?: ILink[];
	wideLandscapeImage?: Image;
	displayLanguageFilter?: boolean;
	availableLanguages?: { language: string }[];
	languageDescriptions?: {
		id: string;
		description: string;
	}[];
	hideBottomBorder?: boolean;
}

export default PageHeader;
